<div class="w-100">
    @for (item of toBePickedArray(); track $index; let i = $index) {
        <div class="d-flex align-items-center">
            @if (teamOnly()) {
                <team-picker [(team)]="item.team" [(teamId)]="item.teamID" [canEdit]="true" class="w-75"> </team-picker>
            } @else if (userOnly()) {
                <user-picker
                    (contactSelected)="contactChanged($event, i)"
                    [currentContactId]="item.contactID"
                    [currentContact]="item.user"
                    [searchAllAssignable]="true"
                    [usersOnly]="true"
                    class="w-75"
                >
                </user-picker>
            } @else {
                <user-team-picker
                    [(teamId)]="item.teamID"
                    [(user)]="item.user"
                    [(userId)]="item.userID"
                    [includeInactiveContacts]="includeInactiveContacts()"
                    class="w-75"
                >
                </user-team-picker>
            }
            @if (toBePickedArray().length > 1) {
                <button (click)="removeItem(i)" class="ace-btn has-icon btn-primary btn-danger m-0 ms-1">
                    <i class="fa fa-minus fa-lg"></i>
                </button>
            }
            @if (i === toBePickedArray().length - 1) {
                <button (click)="addItem()" class="ace-btn has-icon btn-secondary m-0 ms-1">
                    <i class="fa fa-plus fa-lg"></i>
                </button>
            }
        </div>
    }
</div>
